<template>
    <div class="r:20 flex ai:center gap:4 p:8|12 bg:#F8F8F8">
        <div class="inline-flex ai:center gap:4">
            <span class="w:20 h:20 inline-block cursor:pointer" @click="like" :style="{ backgroundImage: `url(${prefix}image/icon_good${isLike === true ? '_active' : ''}.svg)` }"></span>
            <span v-text="likeCount"></span>
        </div>
        <div class="px:4 h:24 inline-flex"><span class="w:1 bg:#EBEBEB"></span></div>
        <div class="inline-flex ai:center gap:4">
            <span class="w:20 h:20 inline-block cursor:pointer" @click="dislike" :style="{ backgroundImage: `url(${prefix}image/icon_bad${isLike === false ? '_active' : ''}.svg)` }"></span>
            <span v-text="dislikeCount"></span>
        </div>
    </div>
</template>

<script setup>
    const prefix = inject("prefix");

    const props = defineProps({
        dislikeCount: { default: 0, type: Number },
        isLike: { default: null, type: [Boolean, Object] },
        likeCount: { default: 0, type: Number },
        post_id: { required: true, type: Number }
    });

    const dislike = () => {
        setLike(false);
    };

    const like = () => {
        setLike(true);
    };

    const setLike = (value) => {
        api("api/post/like", {
            post_id: props.post_id,
            value
        }).done((res) => {
            if (res.success) {
                if (res.is_like === true) {
                    props.isLike = true;
                    props.likeCount += 1;
                } else if (res.is_like === false) {
                    props.isLike = false;
                    props.dislikeCount += 1;
                }
            }
        });
    };
</script>
